import {useDebugValue} from 'react';

import {useAbacusStore} from './';

function useAbacus(props) {
    const {
        store
    } = useAbacusStore(props);

    const result = {
        store
    };

    useDebugValue(result);

    return result;
}

export {useAbacus};
